/* global axios */

import ApiClient from './ApiClient';

class ScheduledMessages extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }
}

export default new ScheduledMessages();
